import { Texture } from 'pixi.js';
import { SpineAnimation, AssetLoader } from "@cc/pixi-app";
import avatarConfig from "../../data/avatar-config.json";
import { storageManager } from './StorageManager';
import { app } from './../app';

class AvatarGenerator {

    constructor(){
        this.varDna = {
            avatar_neck: "neck",
            avatar_hand_left: "hand_left",
            avatar_hand_right: "hand_right",
            outfit_arm_right: "arm_right_1",
            outfit_arm_left: "arm_left_1",
            avatar_ankle_left: "ankle_left",
            avatar_ankle_right: "ankle_right",
            outfit_leg_right: "leg_right_1",
            outfit_leg_left: "leg_left_1",
            outfit_foot_right: "foot_right_1",
            outfit_foot_left: "foot_left_1",
            outfit_waist: "waist_1",
            outfit_body: "body_1",
            avatar_head: "head_1",
            avatar_iris: "iris_1",
            avatar_eyes: "eye_1",
            avatar_eyes_blink: "blink_2",
            avatar_eyebrows: "eyebrows_1",
            avatar_teeth: "teeth_1",
            avatar_lips: "lips_1",
            avatar_nose: "nose_1",
            avatar_hair: "hair_1"
        };

        this.avatarData = {};
    }

    get dna(){
        return this.varDna;
    }

    set dna(newDna){
        this.varDna = newDna;
    }

    getAnimation(anim, key, vehicle){
        avatarConfig.colors.current = storageManager.data.colors;
        this.dna = storageManager.data.dna || this.dna;
        return this.createAnimation(anim, key, this.dna, vehicle);
    }

    updateAnimations(){

        let keys = Object.keys(this.avatarData);
        for (var i = 0; i < keys.length; i++){
            let data = this.avatarData[keys[i]];
            this.assignTextures(
                data.anim,
                data.dir,
                this.dna
            );
        }
    }

    createAnimation(baseName, dir, dnaSequence, vehicle){
        let anim = null;
        anim = new SpineAnimation(baseName);
        anim.setSkinByName("avatar");
        if (Object.keys(this.avatarData).indexOf(baseName) !== -1){
            this.avatarData[baseName].anim = anim;
        }
        else{
            let aData = {
                [baseName]: {
                    anim: anim,
                    dir: dir
                }
            };

            Object.assign(this.avatarData, aData);
        }
        anim.spine.update(0);
        this.assignTextures(anim, dir, dnaSequence, vehicle);
        anim.setAnimation(0, "idle", true);
        return anim;
    }

    assignTextures(anim, dir, dnaSequence){
        if (!anim.spine.transform) return;
        if (anim.spine.state.tracks[0]){
            var time = anim.spine.state.tracks[0].trackTime;
            anim.spine.skeleton.setToSetupPose();
        }
        let slots = anim.spine.skeleton.slots;
        for (var i = 0; i < slots.length; i ++){
            let slotName = slots[i].data.name;
            if (!avatarConfig.parts[slotName]) continue;
            let textSrc = avatarConfig.parts[slotName][dnaSequence[slotName]].texture[dir];
            let texture = new Texture.from(textSrc);
            anim.spine.hackTextureBySlotName(slots[i].data.name, texture, texture.frame);
        }
        if (time) anim.spine.state.tracks[0].trackTime = time;
        AssetLoader.updateGlTextures(app);
        this.tintTextures(anim);
        storageManager.setDna(dnaSequence);
    }

    tintTextures(anim){
        let slots = anim.spine.skeleton.slots;
        for (var i = 0; i < slots.length; i ++){
            if (!avatarConfig.parts[slots[i].data.name]) continue;
            if (avatarConfig.parts[slots[i].data.name].color){
                let type = avatarConfig.parts[slots[i].data.name].color;
                let color = this.hexToRgb(avatarConfig.colors[type][avatarConfig.colors.current[avatarConfig.parts[slots[i].data.name].color]]);
                anim.spine.skeleton.slots[i].color.setFromColor({r: color.r / 255, g: color.g / 255, b: color.b / 255, a: 1});
            }
        }
        storageManager.setColors(avatarConfig.colors.current);
    }

    hexToRgb(hex){
        var result = /^0x?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
        return result ? {
            r: parseInt(result[1], 16),
            g: parseInt(result[2], 16),
            b: parseInt(result[3], 16)
        } : null;
    }
}

export let avatarGenerator = new AvatarGenerator();
